import * as React from "react"
import PropTypes from "prop-types"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  // Prevent mouse wheel from changing number inputs when focused
  const handleWheel = (e) => {
    if (type === 'number' && document.activeElement === e.target) {
      e.target.blur();
    }
  };

  return (
    <input
      type={type}
      onWheel={handleWheel}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-white px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
}

export { Input }
